import moment from 'moment'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const PrivateComponent = (props) => {

    const [isLoggedIn, setIsLoggedIn] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        setIsLoggedIn(false)
        const localuser = JSON.parse(localStorage.getItem('localuser') || '{}')
        if(localuser.token){
            setIsLoggedIn(true)
        }else{
            navigate('/admin/login')
        }

    }, [props.element])

    if(isLoggedIn){
        return(
            props.element
        )
    }else{
        return(
            <div>Loading...</div>
        )
    }
}

export default PrivateComponent